import { render, staticRenderFns } from "./redis.vue?vue&type=template&id=71710c5e&"
import script from "./redis.vue?vue&type=script&lang=js&"
export * from "./redis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports